import React from 'react'

import './answerCard.scss'

const AnswerCard = ({ activeAnswer, answer, onClick }) => {
  return (
    <button
      className={`f-answer ${
        activeAnswer.id === answer.id ? 'f-answer--active' : ''
      }`}
      key={answer.id}
      onClick={onClick}
    >
      <b>{answer.id})</b> {answer.text}
    </button>
  )
}

export default AnswerCard
